import { Card } from 'antd';
import React from 'react';
import styled from 'styled-components';

interface SpecialRequestProps {
  value?: string;
  translations?: any;
}
export default function SpecialRequest({
  value,
  translations,
}: SpecialRequestProps) {
  return (
    <Wrapper>
      <Title>{translations?.['b2b.txt.specialRequest']}</Title>
      <BoxSpecial>
        <TextSpecial>{value}</TextSpecial>
      </BoxSpecial>
    </Wrapper>
  );
}
const Wrapper = styled(Card)`
  border-radius: 12px;
  .ant-card-body {
    padding: 0;
  }
`;

const Title = styled.div`
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid #f0f0f0;
`;

const BoxSpecial = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  margin: 16px;
  padding: 10px;
  background: #f8f8f8;
`;
const TextSpecial = styled.div`
  color: #000;
`;
